'use strict'

class ImageCanvas {
    constructor(name) {
        this._name
        this._w
        this._h
        this._data
        this._context
        this._element

        this.name = name
        this.element = document.getElementById(this.name)

        this.context = this.element.getContext('2d', { alpha: false })

        // Keep drawing crisp by default.
        this.setImageSmoothing(false)

        // Initialize from the DOM element to avoid undefined
        this._w = this.element.width
        this._h = this.element.height
    }

    /**
     * Enable/disable smoothing on this canvas context.
     * @param {boolean} enabled
     */
    setImageSmoothing(enabled) {
        this._context.imageSmoothingEnabled = enabled
        // this._context.mozImageSmoothingEnabled = false; deprecated
        this._context.oImageSmoothingEnabled = enabled
        this._context.webkitImageSmoothingEnabled = enabled
        this._context.msImageSmoothingEnabled = enabled
    }

    // ------------------------------------------------------------------------------
    // GETTER AND SETTERS
    // ------------------------------------------------------------------------------
    get name() {
        return this._name
    }
    set name(v) {
        this._name = v
    }

    get width() {
        return this._w
    }
    set width(w) {
        this._w = w
        this.element.width = w
    }

    get height() {
        return this._h
    }
    set height(h) {
        this._h = h
        this.element.height = h
    }

    get data() {
        return this._data
    }

    set data(v) {
        this._data = v
    }

    get context() {
        return this._context
    }
    set context(v) {
        this._context = v
    }

    get element() {
        return this._element
    }
    set element(v) {
        this._element = v
    }

    // ------------------------------------------------------------------------------
    // PUBLIC METHODS
    // ------------------------------------------------------------------------------
    size(w, h) {
        this._w = w
        this._h = h

        this.context.width = w
        this.context.height = h
        this.element.width = w
        this.element.height = h
    }

    loadData() {
        this._context = this.element.getContext('2d', { alpha: false })

        // Ensure internal width/height are valid before calling getImageData
        if (!Number.isFinite(this._w) || !Number.isFinite(this._h)) {
            this._w = this.element.width
            this._h = this.element.height
        }

        this._data = this.context.getImageData(0, 0, this._w, this._h)
    }
}
export default ImageCanvas
